import React, {useRef} from "react";
import {StepperWrapper} from "../../components/StepperWrapper";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Button from "../../components/Button";
import {checkContentAvlInArray} from "../../util";
import BookingDetailList from "../../components/BookingDetailList";
import TabsMenu from "../../components/TabsMenu";
import "./style.scss";
import config from "config";

const ConfirmBooking = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const customerSlotDetails = useRef(getCustomerSlotDetails());
  const currentSlot = customerSlotDetails.current.currentBookingDetails;
  const isBanco = () => {
    if (customerSlotDetails.current.source.includes("bancofalabella")) {
      return true;
    } else {
      return false;
    }
  };
  const isOffice = customerSlotDetails.current.isOffice;
  const areStandAloneBu = checkContentAvlInArray(
    config.stand_alone_bu_list,
    customerSlotDetails.current.buList
  );
  const confirmBooking = () => {
    if (
      checkContentAvlInArray(
        config.stand_alone_bu_list,
        customerSlotDetails.current.buList
      ) ||
      isBanco()
    ) {
      navigate("/customer/additionalData", {replace: true});
    } else {
      navigate("/customer/slotBooked", {replace: true});
    }
  };

  return (
    <div className="confirm-booking-contetns-wrap">
      <TabsMenu path="confirmBooking" />
      <main className="main-container">
        <StepperWrapper current={2} />
        <div className="heading-subheading">
          <label className="heading">{t("booking.confirmReservation")}</label>
          <label className="office-select-label-text sub-heading">
            {t("booking.checkReservation")}
          </label>
        </div>
        <div className="officequestions officequestions-container">
          <BookingDetailList
            endTime={isBanco() ? "" : currentSlot.selectedSlot.endTime}
            isOffice={isOffice}
            region={
              isOffice || areStandAloneBu
                ? currentSlot.selectedStore.location
                : currentSlot.region.label
            }
            serviceType={currentSlot.selectedSlot.serviceTypes.join(" - ")}
            startTime={currentSlot.selectedSlot.startTime}
            storeName={currentSlot.selectedStore.storeName}
            timeZone={currentSlot.selectedStore.timeZone}
            country={customerSlotDetails.current.country}
            bu={
              isOffice
                ? currentSlot.bu
                : areStandAloneBu
                ? customerSlotDetails.current.bu
                : currentSlot.bu.label
            }
          />
        </div>
        <footer className="footer-div">
          <Button
            value={t("bookslot.btnlabel")}
            handleClick={confirmBooking}
            newDesign={true}
          />
        </footer>
      </main>
    </div>
  );
};

export default ConfirmBooking;
